module.exports = __webpack_public_path__ + "img/full0-min.e8cb6a91.png";